var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoSsnRequiredIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3418_3447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3763 2.21131C20.3755 1.21373 19.6811 0.518663 18.686 0.518663C13.2508 0.517018 7.81566 0.517429 2.38092 0.518663C1.38412 0.518663 0.685626 1.2129 0.684804 2.20597C0.682339 5.45357 0.682749 8.70157 0.684804 11.9492C0.685215 12.9554 1.38043 13.6451 2.3912 13.648C3.19776 13.6505 4.00473 13.6484 4.81129 13.6484H5.02988C4.47314 17.0686 6.95363 20.0412 10.2518 20.2044C11.869 20.2842 13.2849 19.7548 14.4362 18.6125C15.8122 17.2474 16.3053 15.5745 16.0349 13.6484H16.2654C17.072 13.6484 17.879 13.6509 18.6855 13.6476C19.6807 13.6439 20.3759 12.9505 20.3767 11.9545C20.3788 8.70692 20.3792 5.45891 20.3767 2.21131H20.3763ZM10.5143 19.557C7.7906 19.5501 5.60018 17.3399 5.60758 14.6069C5.61498 11.8966 7.8321 9.69793 10.5464 9.70985C13.2677 9.72136 15.4589 11.9225 15.4535 14.639C15.4486 17.367 13.2418 19.5644 10.5143 19.5575V19.557ZM6.17336 11.0178C5.14082 11.0227 4.10868 11.0202 3.07614 11.0186C3.06381 11.0186 3.05189 11.0091 3.01902 10.9952C3.05189 10.5817 3.08353 10.1616 3.11887 9.74191C3.16694 9.16276 3.21953 8.58443 3.26638 8.00528C3.29021 7.71015 3.34937 7.62754 3.6296 7.53464C4.00473 7.4101 4.38028 7.28596 4.78664 7.15114C5.27518 8.12695 5.75714 9.08959 6.26335 10.1007C6.76339 9.10233 7.24659 8.13804 7.74006 7.15238C8.07328 7.26171 8.40158 7.36899 8.72946 7.4771C8.82027 7.5071 8.92874 7.51697 8.99612 7.57492C9.0972 7.66165 9.2254 7.77345 9.24347 7.88978C9.30182 8.26711 9.31168 8.65143 9.34866 9.03246C9.35934 9.14467 9.32195 9.18865 9.21471 9.21414C8.08438 9.4846 7.13812 10.0642 6.35744 10.9216C6.31307 10.9705 6.23582 11.0174 6.17336 11.0174V11.0178ZM18.6535 12.9916C17.7783 12.9928 16.9035 12.9895 16.0284 12.9944C15.9059 12.9953 15.8546 12.9579 15.8127 12.8403C14.956 10.4131 12.7397 8.9297 10.1766 9.06123C10.1297 9.0637 10.0829 9.06123 10.0147 9.06123C9.9806 8.66623 9.94156 8.293 9.91773 7.91896C9.88609 7.4212 9.64778 7.08538 9.1728 6.92384C8.59264 6.72654 8.01206 6.53048 7.41382 6.32825C7.03334 7.08743 6.65862 7.8347 6.26376 8.62265C5.87137 7.83963 5.49705 7.09319 5.11534 6.33154C4.67282 6.48033 4.24099 6.62461 3.80956 6.77053C3.63494 6.8293 3.4599 6.88726 3.28733 6.95179C2.89124 7.10059 2.65909 7.39119 2.62129 7.80798C2.50542 9.08713 2.40311 10.3679 2.29341 11.6701H5.76824C5.6158 11.9944 5.46542 12.2903 5.33599 12.5949C5.16917 12.9887 5.17615 12.9916 4.73939 12.9916C3.95994 12.9916 3.1805 12.992 2.40147 12.9916C1.73913 12.9907 1.34057 12.5949 1.34057 11.934C1.33975 8.69993 1.33975 5.4659 1.34057 2.23186C1.34057 1.56927 1.73666 1.17468 2.40147 1.17427C7.82265 1.17385 13.2438 1.17385 18.665 1.17427C19.3273 1.17427 19.7201 1.57092 19.7201 2.23721C19.7206 5.46425 19.7206 8.69171 19.7201 11.9188C19.7201 12.5978 19.3286 12.9903 18.6531 12.9911L18.6535 12.9916Z",
    fill: "url(#paint0_linear_3418_3447)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.286 1.83088C5.00322 1.82142 3.97438 2.83627 3.9678 4.11747C3.96164 5.38922 4.97282 6.41516 6.24368 6.42585C7.52563 6.43654 8.55694 5.41922 8.56187 4.13926C8.5668 2.86545 7.55644 1.84074 6.286 1.83129V1.83088ZM6.23792 5.76901C5.32659 5.75792 4.61494 5.02216 4.6248 4.10103C4.63425 3.19141 5.37507 2.47497 6.29216 2.48771C7.20596 2.50045 7.91761 3.23621 7.90528 4.15488C7.89296 5.06779 7.15707 5.7797 6.23792 5.7686V5.76901Z",
    fill: "url(#paint1_linear_3418_3447)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3917 2.4967H10.8701V3.13052H18.3917V2.4967Z",
    fill: "url(#paint2_linear_3418_3447)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8755 7.40118H18.3987V6.76819H10.8755V7.40118Z",
    fill: "url(#paint3_linear_3418_3447)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4103 4.47131H10.8687V5.10349H17.4103V4.47131Z",
    fill: "url(#paint4_linear_3418_3447)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6435 11.0879C10.586 11.0566 10.4824 11.0558 10.4249 11.0866C9.28963 11.6991 8.15806 12.3173 7.02731 12.9383C6.9817 12.9634 6.9287 13.0226 6.92623 13.0686C6.91473 13.2569 6.9213 13.446 6.9213 13.6568H7.56721V15.9373C7.45956 15.9438 7.36095 15.95 7.24179 15.957V16.6081H6.93322V17.246H14.1265V16.5957H13.8097V15.9545C13.6898 15.9471 13.5916 15.9414 13.4954 15.9356V13.6523H14.1413C14.1413 13.4464 14.1508 13.2692 14.136 13.0941C14.131 13.0354 14.0764 12.9589 14.0226 12.9297C12.8984 12.3111 11.7722 11.6966 10.6431 11.0879H10.6435ZM8.87587 15.9373H8.24434V13.6655H8.87587V15.9373ZM10.1886 15.9336H9.5567V13.6577H10.1886V15.9336ZM11.5006 15.9381H10.8711V13.6589H11.5006V15.9381ZM12.8179 15.9299H12.1863V13.6581H12.8179V15.9299Z",
    fill: "url(#paint5_linear_3418_3447)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3418_3447",
    x1: 10.5308,
    y1: 0.517578,
    x2: 10.5308,
    y2: 20.2123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3418_3447",
    x1: 6.26483,
    y1: 1.83081,
    x2: 6.26483,
    y2: 6.42593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3418_3447",
    x1: 14.6309,
    y1: 2.4967,
    x2: 14.6309,
    y2: 3.13052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3418_3447",
    x1: 14.6371,
    y1: 6.76819,
    x2: 14.6371,
    y2: 7.40118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3418_3447",
    x1: 14.1395,
    y1: 4.47131,
    x2: 14.1395,
    y2: 5.10349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3418_3447",
    x1: 10.5319,
    y1: 11.064,
    x2: 10.5319,
    y2: 17.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3418_3447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6948,
    height: 19.6948,
    fill: "white",
    transform: "translate(0.683105 0.517212)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSsnRequiredIcon);
export default __webpack_public_path__ + "static/media/no-ssn-required-icon.128ce7a724e7f78204e105a62c19e80a.svg";
export { ForwardRef as ReactComponent };